import { Popover } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {

        const popover = new Popover(el, {
            trigger: 'manual',
            html: true,
            animation: false,
        });

        el.addEventListener('mouseenter', () => {
            popover.show();
        });

        el.addEventListener('mouseleave', () => {
            popover.hide();
        });
    });

    document.body.addEventListener('click', function (e) {
        document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (el) {
            if (!el.contains(e.target)) {
                const instance = Popover.getInstance(el);
                if (instance) instance.hide();
            }
        });
    });
});
